class Intersection {
    constructor(el, callback, options) {
        this.el = document.querySelectorAll(el);
        this.callback = callback;
        this.options = Object.assign({
            root: null,
            rootMargin: '0px',
            threshold: .5
        }, options);
        this.el.forEach((item) => {
            const observer = new IntersectionObserver((entries) => {
                entries.forEach((item) => {
                    this.callback(item);
                })
            }, this.options);
            observer.observe(item);
        })
    }
}
export default Intersection;